import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './ProjectActions.module.scss';
import Swal from 'sweetalert2';
import { hideCanvas } from '~loader';
import { onErrorShowMessage } from '~src/errors';

async function deleteProjectHandler(canvasId, setIsDeleted) {
  try {
    Swal.fire({
      text: 'Sto eliminando il progetto...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton: false,
      confirmButtonColor: '#278e8e',
      didOpen: () => {
        Swal.showLoading();
      },
    });
    await hideCanvas(canvasId);
    setIsDeleted(true);
    Swal.hideLoading();
    Swal.fire({
      title: 'Eliminato!',
      html: 'Il progetto &egrave; stato eliminato con successo.',
      icon: 'success',
      confirmButtonColor: '#278e8e',
    });
  } catch (error) {
    console.error(error);
    onErrorShowMessage();
  }
}

function ProjectActions(props) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!props.visible) {
      setIsOpen(false);
    }
  }, [props.visible]);

  return (
    <div
      onClick={() => setIsOpen(!isOpen)}
      className={styles.projectActionsAbsoluteContainer}
      style={{ display: props.visible ? 'block' : 'none' }}
    >
      <div className={styles.projectActionsRelativeContainer}>
        <div style={{ display: isOpen ? 'block' : 'none' }}>
          <div className={styles.contextMenuApri}>
            <a
              href={`/canvas/${props.objectId}`}
              data-navigo=""
              style={{ textDecoration: 'none' }}
            >
              <div className={styles.item}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={16}
                  height={16}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  style={{ marginRight: '5px' }}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 6H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-4M14 4h6m0 0v6m0-6L10 14"
                  />
                </svg>
                Apri
              </div>
            </a>
          </div>
          <div className={styles.contextMenuElimina}>
            <div
              className={styles.item}
              onClick={() => {
                deleteProjectHandler(props.objectId, props.setIsDeleted);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                width={16}
                height={16}
                style={{ marginRight: '5px' }}
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="m10 14 2-2m0 0 2-2m-2 2-2-2m2 2 2 2m7-2a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"
                />
              </svg>
              Elimina
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

ProjectActions.propTypes = {
  objectId: PropTypes.string,
  visible: PropTypes.bool,
  setIsDeleted: PropTypes.func,
};

export default ProjectActions;
